import { render, staticRenderFns } from "./UserActivity.vue?vue&type=template&id=2d7969f2"
import script from "./UserActivity.vue?vue&type=script&lang=ts"
export * from "./UserActivity.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports